<template>
  <div id="main" v-if="loggedIn">
    <TheHeader />
    <div id="contents">
      <div class="filters">
        <DirectoryFilters />
      </div>

      <div class="data">
        <DirectoryData />
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import DirectoryFilters from "@/components/DirectoryFilters.vue";
import DirectoryData from "@/components/DirectoryData.vue";

import { LoaderPlugin } from "vue-google-login";
import Vue from "vue";

Vue.use(LoaderPlugin, {
  client_id:
    "280433113103-encb95qml98rf4gqrhbejj2eml1rojsm.apps.googleusercontent.com"
});

export default {
  name: "home",
  components: {
    TheHeader,
    TheFooter,
    DirectoryFilters,
    DirectoryData
  },
  data() {
    return {
      loggedIn: false
    };
  },
  created() {
    Vue.GoogleAuth.then(async auth2 => {
      if (!(await auth2.isSignedIn.get())) {
        this.$router.push({ name: "login" });
      } else {
        this.loggedIn = true;
      }
    });
  }
};
</script>

<style scoped>
#main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

#contents {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.data,
.filters {
  margin-bottom: 15px;
  padding: 20px;
  max-width: 900px;
  width: 900px;
  background: #fafafa;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
}

.data {
  padding: 0;
}

.filters {
  margin-top: 15px;
}

p {
  text-align: center;
}

@media only screen and (max-width: 767px) {
  .data,
  .filters {
    margin-bottom: 15px;
    padding: 0 15px;
    max-width: 375px;
    width: 400px;
  }
  .data {
    padding: 0;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .data,
  .filters {
    margin-bottom: 15px;
    padding: 15px;
    max-width: 700px;
    width: 100%;
  }
  .data {
    padding: 0;
  }
}
</style>
